import type { Plan, Subscription } from '@court-sync/shared';
import {
  normalizeSubscriptionTier,
  resolveSubscriptionTierForDisplay,
  type SubscriptionTier,
} from '@court-sync/shared';

/**
 * Resolves the academy owner's effective subscription tier from Stripe plan + loaded plans catalog.
 * Mirrors the logic in `useFeatureAccess` so tier-derived flags can live on the subscription store.
 */
export function resolveCurrentSubscriptionTier(
  subscription: Subscription | null | undefined,
  plans: Plan[] | null | undefined
): SubscriptionTier {
  if (!subscription?.planId || !plans?.length) return 'starter';
  const plan = plans.find((p) => p.id === subscription.planId);
  if (!plan) return 'starter';
  const internalId = (plan as { internalId?: string | null }).internalId;
  const fromInternal = normalizeSubscriptionTier(internalId ?? null);
  if (fromInternal) return fromInternal;
  return resolveSubscriptionTierForDisplay(plan.name, internalId);
}
